import { format, parseISO } from 'date-fns';

export const LAYOUTS = [
  { value: 'both', label: 'Units grid + orders by day' },
  { value: 'grid', label: 'Product × day units grid' },
  { value: 'orders', label: 'Orders by day' },
];
export const DATE_FIELDS = [
  { value: 'dispatch', label: 'Dispatch (production) date' },
  { value: 'delivery', label: 'Customer delivery date' },
];
export const INCLUDES = [
  { value: 'all', label: 'All orders except cancelled' },
  { value: 'open', label: 'Only not yet dispatched' },
];
export const WEEK_COUNTS = [1, 2, 3, 4];

export const STATUS_LABELS = {
  draft: 'Not started', pending: 'Pending', in_progress: 'In progress', ready: 'Ready',
  locked: 'Ready', dispatched: 'Dispatched', completed: 'Completed',
};

export const num = (n, dp = 0) => {
  const v = Number(n) || 0;
  return v.toLocaleString('en-IE', { minimumFractionDigits: Number.isInteger(v) ? 0 : dp, maximumFractionDigits: Number.isInteger(v) ? 0 : dp || 1 });
};

export const weekTitle = (w) => `Week ${w.week_number}, ${w.year}`;
export const weekRange = (w) => `${format(parseISO(w.start), 'dd MMM')} – ${format(parseISO(w.end), 'dd MMM yyyy')}`;
export const dayShort = (iso) => format(parseISO(iso), 'EEE dd');
export const dayLong = (iso) => format(parseISO(iso), 'EEEE dd MMMM');
export const optionLabel = (list, value) => list.find((o) => o.value === value)?.label || value;
